<div class="layout-topbar">
    <p-progressBar
        *ngIf="loading"
        mode="indeterminate"
        [style]="{ height: '6px', position: 'absolute', top: '0', left:'0', width:'100%' }"
    >
    </p-progressBar>

    <button #menubutton pButton [rounded]="true" [text]="true" size="large" class="p-link layout-menu-button layout-topbar-button ml-0" (click)="layoutService.onMenuToggle()">
        <p-inputicon styleClass="pi pi-bars" />
    </button>

    <button #topbarmenubutton pButton [rounded]="true" [text]="true" size="large" class="p-link layout-topbar-menu-button layout-topbar-button" (click)="layoutService.showProfileSidebar()">
        <p-inputicon styleClass="pi pi-ellipsis-v" />
    </button>

    <div #topbarmenu class="layout-topbar-menu" [ngClass]="{'layout-topbar-menu-mobile-active': layoutService.state.profileSidebarVisible}">

        <div *ngIf="currentOrganisation" class="flex align-items-center gap-2 mr-4">
            <i class="pi pi-building" style="opacity: 75%;"></i>
            <div class="flex flex-col" style="flex-direction: column;">
                <span style="opacity: 75%;">Organisation</span>
                <span class="font-bold uppercase">{{ currentOrganisation.name }}</span>
            </div>
        </div>
        <!-- <p-button icon="pi pi-database" (onClick)="op2.toggle($event)" [rounded]="true" label="{{ currentCompany.name }}" severity="primary" size="medium" class="mr-2" *ngIf="currentCompany"> -->
        <p-button icon="pi pi-database" (onClick)="op2.toggle($event)" [rounded]="true" label="{{ currentCompany.name }}" severity="primary" size="medium" class="mr-2" *ngIf="isSelectButtonShown">
        </p-button>
        <p-button class="mr-2" (click)="toggleDarkMode()" [rounded]="true" [text]="true" severity="secondary" size="large">
            <i [ngClass]="{ 'pi ': true, 'pi-moon': theme === 'lara-dark-indigo', 'pi-sun': theme === 'lara-light-indigo' }"></i>
            <!-- <i [ngClass]="{ 'pi ': true, 'pi-moon': theme === 'lara-light-indigo', 'pi-sun': theme === 'lara-dark-indigo' }"></i> -->
        </p-button>
        <p-button icon="pi pi-user" (onClick)="op.toggle($event)" [rounded]="true" [text]="true" severity="secondary" size="large" *ngIf="user">
        </p-button>
        <p-popover #op>
            <div class="head" *ngIf="isSuperAdmin" style="
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                background: #6366f1;
                text-align: center;
                border-top-left-radius: 6px;
                border-top-right-radius: 6px;
                padding: 3px;
                font-weight: 900;
                color: #FEFEFE;
            ">
                Super Admin
            </div>
            <div class="content" *ngIf="user" [ngStyle]="{'padding-top': isSuperAdmin ? '20px' : ''}">
                <div class="user flex justify-content-center align-items-center flex-column">
                    <div class="name mb-1"><span *ngIf="user.firstname">{{ user.firstname }}</span><span *ngIf="user.name" class="ml-1">{{ user.name }}</span></div>
                    <div class="email">{{ user.email }}</div>
                </div>
                <p-divider/>
                <div class="account flex justify-content-center">
                    <p-button icon="pi pi-user" [routerLink]="'/pages/profile'" [rounded]="true" label="Gérer mon compte" (onClick)="op.toggle($event)">
                    </p-button>        
                </div>
            </div>
        </p-popover>
        <p-popover #op2>
            <div class="head" *ngIf="isSuperAdmin" style="
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                background: #6366f1;
                text-align: center;
                border-top-left-radius: 6px;
                border-top-right-radius: 6px;
                padding: 3px;
                font-weight: 900;
                color: #FEFEFE;
            ">
                Super Admin
            </div>
            <div class="content" *ngIf="user" [ngStyle]="{'padding-top': isSuperAdmin ? '20px' : ''}">
                <div class="base flex justify-content-center align-items-center flex-column" *ngIf="currentCompany">
                    <div class="mb-1">Ma base active :</div>
                    <div class="mb-1">{{ currentCompany.name }}</div>
                    <div class="role flex justify-content-center">
                        Rôle :
                        <span *ngIf="isAdmin" class="ml-1">Admin</span>
                        <span *ngIf="isEditor" class="ml-1">Éditeur</span>
                        <span *ngIf="isReader" class="ml-1">Lecteur</span>
                        <span *ngIf="isSuperAdmin && !isAdmin && !isEditor && !isReader" class="ml-1">Vous n'êtes pas associé à cette base. Vous y avez accès en tant que super admin.</span>
                    </div>
                </div>
                <p-divider *ngIf="user.is_superadmin || user.companies.length > 1"/>
                <div class="switch flex justify-content-center mt-3" *ngIf="user.is_superadmin || user.companies.length > 1">
                    <p-button class="switch" icon="pi pi-sign-in" (onClick)="showDialog()" [rounded]="true" label="Changer de base" (onClick)="op2.toggle($event)">
                    </p-button>
                </div>
                <div class="switch flex justify-content-center mt-3" *ngIf="user.is_superadmin || user.organisations.length > 1">
                    <p-button class="switch" icon="pi pi-sign-in" (onClick)="showDialogOrga()" [rounded]="true" label="Changer d'organisation" (onClick)="op2.toggle($event)">
                    </p-button>
                </div>
            </div>
        </p-popover>
        <p-button icon="pi pi-sign-out" (onClick)="logout()" [rounded]="true" [text]="true" severity="secondary" size="large">
        </p-button>
    </div>
</div>